/*
 * hyperion-index:begin
 * ---
 * path: hyperion-fe/src/platform/auth/useAuth.ts
 * layer: web
 * area: hooks
 * kind: hook
 * web_root: hooks
 * relpath: web/src/platform/authentication/hooks/useAuth.ts
 * filename: useAuth.ts
 * extension: ts
 * ---
 * hyperion-index:end
 */

import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
